export const copyClipboard = async (phrase: string) => {
    try {
        await navigator.clipboard.writeText(phrase);
    } catch (err) {
        console.log("there was an error")
    }
}